"use client";

import { motion } from "framer-motion";
import Image from "next/image";

interface AnimatedCardsProps {
  text: string;
  image: string;
  delay?: number;
}

export default function AnimatedCard({ text, image, delay }: AnimatedCardsProps) {
  return (
    <motion.div
      initial={{ y: -10, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3, delay: delay }}
      viewport={{ once: true }}
      className="relative h-50 w-full rounded-xs border-1 border-green-border bg-green-card p-20 md:h-40 md:w-80"
    >
      <Image src={image} alt="flag" className="absolute top-4 right-4 h-16 w-auto md:h-16"></Image>
      <h3 className="absolute bottom-4 left-4">{text}</h3>
    </motion.div>
  );
}
